import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/Area?status=1";

export default class AreaService {

    getDropDown=(cityIds)=>{
      return  http.get(`${apiDropDownEndpoint}&city_ids=${cityIds}`) 
    }

    getAreaDropDown=(cityIds)=>{
      return  http.get(`${apiDropDownEndpoint}`) 
    }

}
